<script>
  import HorMenuItem from './HorMenuItem.svelte'
</script>

<div class="hor-menu">
  <HorMenuItem/>
</div>